import { getSessionToken } from "../lib/sessionToken";
const customSpecialties = [
  "LACN",
  "LACN Gastro",
  "lacn_gyn_onc",
  "self_serve",
  "ironwood medonc",
  "ironwood gyn",
  "ironwood radonc",
  "tenonc medonc",
];

export const isCustomSpecialty = (specialty) => {
  return customSpecialties.includes(specialty);
};

export const getDoctorSpecialty = async () => {
  if (!getSessionToken()) {
    return null;
  }
  try {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    const response = await fetch(`${process.env.REACT_APP_API_URL}/dashboard/`, {
      method: "GET",
      headers: {
        token: getSessionToken(),
        pickedDate: formattedDate,
      },
    });

    const parseRes = await response.json();

    if (parseRes && parseRes.length > 0 && parseRes[0].specialty) {
      return parseRes[0].specialty;
    }

    return null;
  } catch (err) {
    console.error("Error fetching doctor specialty:", err);
    return null;
  }
};
